import React from 'react';
import styles from './LinkWithIcon.module.scss';
import classnames from 'classnames';

export interface LinkWithIconProps {
  href?: string;
  onClick?: () => void;
  className?: string;
  icon: React.ReactElement;
  children: React.ReactNode;
}

export const LinkWithIcon = ({ href, onClick, icon, className, children }: LinkWithIconProps) => {
  const finalIcon = React.cloneElement(icon, {
    className: classnames(icon.props.className, styles.icon),
  });
  return (
    <a className={classnames(styles.container, className)} href={href} onClick={onClick}>
      {children}
      {finalIcon}
    </a>
  );
};
